import { Dispatch } from 'redux';
import CrudActionContainer from './CrudActionContainer';
import AffiliatesController from '../controllers/AffiliatesController';
import affiliatesHandler from '../errorHandlers/affiliates-handler';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';

class AffiliatesCRUDActions extends CrudActionContainer {
  deactivateAction: string;

  constructor() {
    super('AFFILIATES');
    this.deactivateAction = this.makeActionKey('DEACTIVATE');
  }

  create(paypalEmail?: string) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));
      try {
        const response = await AffiliatesController.post(paypalEmail);
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  fetchForCurrentUser() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAction));
      try {
        const response = await AffiliatesController.fetchForCurrentUser();
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        affiliatesHandler(dispatch)(e);
      }
    };
  }

  update(id: number, paypalEmail: string) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));
      try {
        const response = await AffiliatesController.putAffiliate(
          id,
          paypalEmail,
        );
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  delete(affiliateId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAction));
      try {
        const response = await AffiliatesController.deleteAffiliate(
          affiliateId,
        );
        dispatch(this.deactivateAffiliate());
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  deactivateAffiliate() {
    return {
      type: this.deactivateAction,
    };
  }
}

const affiliatesCRUDActions = new AffiliatesCRUDActions();

export default affiliatesCRUDActions;
